import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  es: {
    translation: {
      // App
      "app_subtitle": "Herramientas modulares para financiamiento de equipo comercial",
      "login_title": "Bienvenido",
      "login_subtitle": "Ingresa tus credenciales para acceder",
      "invalid_credentials": "Credenciales inválidas",
      
      // Login Features
      "feature_credit": "Análisis de Crédito",
      "feature_appraisals": "Tasaciones de Equipo",
      "feature_bank": "Análisis Bancario",
      
      // Common
      "save": "Guardar",
      "cancel": "Cancelar",
      "delete": "Eliminar",
      "edit": "Editar",
      "create": "Crear",
      "back": "Volver",
      "loading": "Cargando...",
      "search": "Buscar",
      "filter": "Filtrar",
      "actions": "Acciones",
      "status": "Estado",
      "date": "Fecha",
      "notes": "Notas",
      "yes": "Sí",
      "no": "No",
      "none": "Ninguno",
      "all": "Todos",
      "error": "Error",
      "success": "Éxito",
      
      // Auth
      "login": "Iniciar Sesión",
      "logout": "Cerrar Sesión",
      "email": "Correo Electrónico",
      "password": "Contraseña",
      "welcome_back": "Bienvenido de nuevo",
      
      // Navigation
      "dashboard": "Dashboard",
      "clients": "Clientes",
      "users": "Usuarios",
      "tier_config": "Config. Tiers",
      "tools": "Herramientas",
      "admin": "Admin",
      
      // Apps
      "asset_appraisal": "Tasación de Activos",
      "bank_analysis": "Análisis Bancario",
      "credit_evaluation": "Evaluación Crediticia",
      "pricing": "Precios y Estructura",
      "summary": "Resumen y Decisión",
      
      // Dashboard
      "recent_activity": "Actividad Reciente",
      "total_clients": "Total Clientes",
      "total_appraisals": "Tasaciones",
      "total_bank_analyses": "Análisis Bancarios",
      "credit_evaluations": "Evaluaciones",
      
      // Client
      "new_client": "Nuevo Cliente",
      "client_name": "Nombre del Cliente",
      "phone": "Teléfono",
      "immigration_status": "Estatus Migratorio",
      "has_cdl": "Tiene CDL",
      "years_experience": "Años de Experiencia",
      "no_clients": "No hay clientes registrados",
      
      // Asset Appraisal
      "new_appraisal": "Nueva Tasación",
      "asset_type": "Tipo de Activo",
      "semi_truck": "Camión (Semi-Truck)",
      "pickup_truck": "Pickup Truck",
      "trailer": "Trailer",
      "other_equipment": "Otro Equipo",
      "make": "Marca",
      "model": "Modelo",
      "year": "Año",
      "mileage": "Millaje",
      "sleeper_type": "Tipo de Sleeper",
      "cab_type": "Tipo de Cabina",
      "condition": "Condición",
      "requested_price": "Precio Solicitado",
      "appraised_value": "Valor Tasado",
      "search_comparables": "Buscar Comparables",
      "calculate_value": "Calcular Valor Tasado",
      "market_comps": "Comparables del Mercado",
      "average_price": "Precio Promedio",
      "lowest_price": "Precio Más Bajo",
      "variance_warning": "ALERTA: Varianza Alta",
      "no_comps": "No hay comparables aún",
      "open_listing": "Ver Listado",
      
      // Bank Analysis
      "new_bank_analysis": "Nuevo Análisis Bancario",
      "upload_statements": "Subir Estados de Cuenta",
      "upload_description": "Sube archivos PDF para análisis automático con IA",
      "drag_files": "Arrastra archivos aquí o haz clic para seleccionar",
      "select_files": "Seleccionar Archivos",
      "analyzing": "Analizando...",
      "files_analyzed": "Archivos Analizados",
      "manual_entry": "Entrada Manual",
      "avg_monthly_income": "Ingreso Mensual Promedio",
      "avg_ending_balance": "Balance Final Promedio",
      "min_monthly_deposit": "Depósito Mínimo",
      "min_ending_balance": "Balance Final Mínimo",
      "months_analyzed": "Meses Analizados",
      
      // Credit Evaluation
      "new_evaluation": "Nueva Evaluación",
      "equipment_price": "Precio del Equipo",
      "assigned_tier": "Tier Asignado",
      "eligible_tiers": "Tiers Elegibles",
      "no_tier_eligible": "No califica para ningún tier",
      "tier_override": "Override de Tier",
      "override_comment": "Comentario del Override",
      
      // Pricing
      "new_deal": "Nueva Estructura",
      "down_payment": "Enganche",
      "amount_financed": "Monto Financiado",
      "term_months": "Plazo (Meses)",
      "interest_rate": "Tasa de Interés",
      "monthly_payment": "Pago Mensual",
      "ltv": "LTV",
      "deal_warnings": "Advertencias",
      
      // Summary
      "new_summary": "Nuevo Resumen",
      "recommendation": "Recomendación",
      "internal_notes": "Notas Internas",
      "linked_data": "Datos Vinculados",
      "export_pdf": "Exportar PDF",
      
      // Status values
      "draft": "Borrador",
      "completed": "Completado",
      "pending": "Pendiente",
      "approved": "Aprobado",
      "declined": "Declinado",
      
      // Conditions
      "excellent": "Excelente",
      "good": "Bueno",
      "fair": "Regular",
      "needs_repair": "Necesita Reparación",
      
      // Roles
      "role_admin": "Administrador",
      "role_manager": "Manager",
      "role_analyst": "Analista",
      "role_trainee": "Trainee",
      
      // Users Management
      "user_management": "Gestión de Usuarios",
      "create_user": "Crear Usuario",
      "full_name": "Nombre Completo",
      "user_role": "Rol del Usuario",
      "active": "Activo",
      "inactive": "Inactivo"
    }
  },
  en: {
    translation: {
      // App
      "app_subtitle": "Modular tools for commercial equipment financing",
      "login_title": "Welcome",
      "login_subtitle": "Enter your credentials to access",
      "invalid_credentials": "Invalid credentials",
      
      // Login Features
      "feature_credit": "Credit Analysis",
      "feature_appraisals": "Equipment Appraisals",
      "feature_bank": "Bank Analysis",
      
      // Common
      "save": "Save",
      "cancel": "Cancel",
      "delete": "Delete",
      "edit": "Edit",
      "create": "Create",
      "back": "Back",
      "loading": "Loading...",
      "search": "Search",
      "filter": "Filter",
      "actions": "Actions",
      "status": "Status",
      "date": "Date",
      "notes": "Notes",
      "yes": "Yes",
      "no": "No",
      "none": "None",
      "all": "All",
      "error": "Error",
      "success": "Success",
      
      // Auth
      "login": "Sign In",
      "logout": "Sign Out",
      "email": "Email",
      "password": "Password",
      "welcome_back": "Welcome Back",
      
      // Navigation
      "dashboard": "Dashboard",
      "clients": "Clients",
      "users": "Users",
      "tier_config": "Tier Config",
      "tools": "Tools",
      "admin": "Admin",
      
      // Apps
      "asset_appraisal": "Asset Appraisal",
      "bank_analysis": "Bank Analysis",
      "credit_evaluation": "Credit Evaluation",
      "pricing": "Pricing & Structure",
      "summary": "Decision & Summary",
      
      // Dashboard
      "recent_activity": "Recent Activity",
      "total_clients": "Total Clients",
      "total_appraisals": "Appraisals",
      "total_bank_analyses": "Bank Analyses",
      "credit_evaluations": "Evaluations",
      
      // Client
      "new_client": "New Client",
      "client_name": "Client Name",
      "phone": "Phone",
      "immigration_status": "Immigration Status",
      "has_cdl": "Has CDL",
      "years_experience": "Years of Experience",
      "no_clients": "No clients registered",
      
      // Asset Appraisal
      "new_appraisal": "New Appraisal",
      "asset_type": "Asset Type",
      "semi_truck": "Semi-Truck",
      "pickup_truck": "Pickup Truck",
      "trailer": "Trailer",
      "other_equipment": "Other Equipment",
      "make": "Make",
      "model": "Model",
      "year": "Year",
      "mileage": "Mileage",
      "sleeper_type": "Sleeper Type",
      "cab_type": "Cab Type",
      "condition": "Condition",
      "requested_price": "Requested Price",
      "appraised_value": "Appraised Value",
      "search_comparables": "Search Comparables",
      "calculate_value": "Calculate Appraised Value",
      "market_comps": "Market Comparables",
      "average_price": "Average Price",
      "lowest_price": "Lowest Price",
      "variance_warning": "WARNING: High Variance",
      "no_comps": "No comparables yet",
      "open_listing": "View Listing",
      
      // Bank Analysis
      "new_bank_analysis": "New Bank Analysis",
      "upload_statements": "Upload Statements",
      "upload_description": "Upload PDF files for automatic AI analysis",
      "drag_files": "Drag files here or click to select",
      "select_files": "Select Files",
      "analyzing": "Analyzing...",
      "files_analyzed": "Files Analyzed",
      "manual_entry": "Manual Entry",
      "avg_monthly_income": "Avg Monthly Income",
      "avg_ending_balance": "Avg Ending Balance",
      "min_monthly_deposit": "Min Monthly Deposit",
      "min_ending_balance": "Min Ending Balance",
      "months_analyzed": "Months Analyzed",
      
      // Credit Evaluation
      "new_evaluation": "New Evaluation",
      "equipment_price": "Equipment Price",
      "assigned_tier": "Assigned Tier",
      "eligible_tiers": "Eligible Tiers",
      "no_tier_eligible": "Does not qualify for any tier",
      "tier_override": "Tier Override",
      "override_comment": "Override Comment",
      
      // Pricing
      "new_deal": "New Deal Structure",
      "down_payment": "Down Payment",
      "amount_financed": "Amount Financed",
      "term_months": "Term (Months)",
      "interest_rate": "Interest Rate",
      "monthly_payment": "Monthly Payment",
      "ltv": "LTV",
      "deal_warnings": "Warnings",
      
      // Summary
      "new_summary": "New Summary",
      "recommendation": "Recommendation",
      "internal_notes": "Internal Notes",
      "linked_data": "Linked Data",
      "export_pdf": "Export PDF",
      
      // Status values
      "draft": "Draft",
      "completed": "Completed",
      "pending": "Pending",
      "approved": "Approved",
      "declined": "Declined",
      
      // Conditions
      "excellent": "Excellent",
      "good": "Good",
      "fair": "Fair",
      "needs_repair": "Needs Repair",
      
      // Roles
      "role_admin": "Administrator",
      "role_manager": "Manager",
      "role_analyst": "Analyst",
      "role_trainee": "Trainee",
      
      // Users Management
      "user_management": "User Management",
      "create_user": "Create User",
      "full_name": "Full Name",
      "user_role": "User Role",
      "active": "Active",
      "inactive": "Inactive"
    }
  }
};

// Get saved language or default to English
const savedLanguage = typeof window !== 'undefined' 
  ? localStorage.getItem('language') || 'en' 
  : 'en';

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLanguage,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
